module.exports = __webpack_public_path__ + "img/s2.5e10294b.svg";